<template>
  <div >
    <el-dialog 
      title="Edit Rule" 
      :before-close="handleClose" 
      :show-close="false" 
      :visible.sync="visible">    
      <rule :rule="rule" :campaign="rule.campaign"></rule>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" v-if="rule.events" @click="addEmptyAction">Add Action</el-button>
        <el-button size="small" @click="handleClose">Cancel</el-button>
        <el-button :loading="saving" size="small" type="primary" @click="handleSave(rule)">Save Rule</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Rule from '@/components/rules/Rule';
import ruleMixins from '../../mixins/rules';

export default {
  name: 'RuleEdit',
  components: { Rule },
  mixins: [ruleMixins],
  props: {
    rule: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSave(rule) {
      this.$store.dispatch('rules/updateRule', rule);
    },
  },
  watch: {
    saving(newValue) {
      if (newValue === true) this.$emit('close');
    },
  },
};
</script>


// WEBPACK FOOTER //
// RuleEdit.vue?78a9ec76